<template>
    <div class="checkout-button">
        <div class="action">
            <div class="consent">
            <p class="text-center">By placing order you agree to our <br/><router-link to="/Terms">Terms &amp; Conditions</router-link></p>
            </div>
            <div class="submit">
            <button @click.prevent="submitPurchase()" :disabled="buttonEnabled" class="button-dark" :class="buttonEnabled">Place Order</button>
            </div>
        </div>
    </div>
</template>

<script>
import vCheckbox from '@/components/checkout/Checkbox.vue'
export default {
    name: "checkout-button",
    data:() => ({
        userConsent: false,
        lockedButtonOnOrderSend: false
    }),
    components: {
        vCheckbox
    },
    methods: {
        submitPurchase () {
            if(!this.lockedButtonOnOrderSend)
            {
                this.lockedButtonOnOrderSend = true;
                this.$emit('orderSubmitted')
            }
        }
    },
    computed: {
        buttonEnabled () {
            if (this.$store.getters['CART/CART'].length === 0) return 'disabled'
            if (this.lockedButtonOnOrderSend || !this.$store.getters['CHECKOUT/VALIDATED']) return 'disabled'
        }
    },
}
</script>

<style lang="postcss" scoped>

.checkout-button {
    width: 100%; 
    border-left: 1px solid #979797;
    border-right: 1px solid #979797;
}

.action {
    display: flex;
    flex-direction: column;
    width: 100%;
  
  }

  .consent {
    padding: 10%;
    display: flex;
    justify-content: center;
    flex-flow: row nowrap;
  }

  .consent p {
    text-align: left;
    padding-left: 5%;
    text-align: center;
  }

    .consent p a {
        color: inherit;
        text-decoration: none;
    }
    .consent p a:hover {
        text-decoration: underline;
    }
  .consent-check  {
      margin-top: 5%;
  }

  .consent-check .checkbox {
    margin: 1em auto;
  }

  .submit {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  button {
    background: #464646;
    color: #fff;
    width: 256px;
    margin-bottom: 3em;
  }

  button.disabled {
    background: #fff;
    color: #000;
    cursor: no-drop;
  }

  button.disabled:hover {
  }
@media screen and (max-width: 768px) {
     .checkout-button {
        margin-bottom: 10%;
        border: 1px solid #979797;
    }

}
</style>